const state = {
  isLoading: false,
};

export default state;
